<template>
  <v-navigation-drawer location="end" permanent rail>
    <v-list density="compact" nav>
      <template v-for="t in tabs" :key="t">
        <template v-if="this[t.storage] && this[t.storage].length">
          <v-sheet v-slot:default="length = this[t.storage].length">
            <v-avatar
                :style="`cursor: ${length > 0 ? 'pointer' : 'default'}`"
                v-on:click="length > 0 ? activate_tab(t.name) : null"
                class="mb-2 d-flex justify-center flex-column align-center"
                :class="{ 'my-icon-button' : length > 0 }"
                :variant="tab === t.name ? 'outlined' : 'text'"
                rounded
                :color="t.color"
            >
              <v-icon :icon="['fas', tab && tab !== t.name ? 'xmark' : t.icon]" :shake="length > 0 && t.shake" class="bigger" />
            </v-avatar>
          </v-sheet>
        </template>
      </template>
    </v-list>
  </v-navigation-drawer>

  <v-navigation-drawer location="end" v-if="tab" :width="tabs[tabs.findIndex(el => el.name === tab)].width">
    <Info__WP_Widget v-if="tab === 'info'" />
    <Users__WP_Widget v-if="tab === 'users'" />
  </v-navigation-drawer>
</template>

<script>

import Info__WP_Widget from "@/components/wp_planner/widgets/info.widget.wp.vue";
import Users__WP_Widget from "@/components/wp_planner/widgets/users.widget.wp.vue";
import { InfoBlock } from "@/store/wp_planner/info.store";
import { RightDrawer } from "@/store/wp_planner/misc.store";
import { Specialists } from "@/store/wp_planner/specialists.store";

export default {
  name: "Right__WP_Drawer",
  components: {
    Users__WP_Widget,
    Info__WP_Widget
  },
  data() {
     return {
       tabs: [
         {
           name: 'info',
           icon: 'fa-xmark',
           color: 'green-darken-4',
           storage: 'info',
           type: 'hidden',
           width: 300
         },
         {
           name: 'users',
           icon: 'fa-user',
           color: 'green-darken-4',
           storage: 'specialists',
           type: 'disabled',
           width: 240
         }
       ]
     }
  },
  watch: {
    info(value) {
      if (value) {
        this.tab = 'info'
      } else if (value === null) {
        this.tab = null
      }
    }
  },
  methods: {
    activate_tab: function (value) {
      if (this.tab && this.tab === value) {
        if (this.tab === 'info') {
          this.info = null
        }
        this.tab = null
      } else {
        if (value !== 'info') {
          this.info = null
        }
        this.tab = value
      }
    }
  },
  computed: {
    tab: {
      get() {
        return RightDrawer().get()
      },
      set(value) {
        RightDrawer().set(value)
      }
    },
    info: {
      get() {
        return InfoBlock().get()
      },
      set(value) {
        InfoBlock().set(value)
      }
    },
    specialists: {
      get() {
        return Specialists().get()
      },
      set(value) {
        Specialists().set(value)
      }
    },
  }
}
</script>

<style scoped>
.bigger {
  font-size: 25px !important;
}
</style>
